<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@addCertificate">Add Certificate</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editCertificate">Edit Certificate</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addCertificateForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@descriptionLabel">Description</mat-label>
        <input data-testid="add_edit_certificate_description" i18n-placeholder="@@descriptionPlaceholder" matInput id="description" placeholder="Description" name="description" formControlName="description" required />
        <mat-error>
          @if (!addCertificateForm.get('description').valid && addCertificateForm.get('description').touched) {
              @if (addCertificateForm.get('description').errors && addCertificateForm.get('description').errors['required'] || addCertificateForm.get('description').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@expireDateLabel">Expire date</mat-label>
        <input [min]="minDate" data-testid="add_edit_certificate_date" placeholder="Expire date" i18n-placeholder="@@expireDatePlaceholder" id="expireDate" name="expireDate" formControlName="expireDate" required matInput [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>
          @if (!addCertificateForm.get('expireDate').valid && addCertificateForm.get('expireDate').touched) {
            @if (addCertificateForm.get('expireDate').errors && addCertificateForm.get('expireDate').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (!addCertificateForm.get('expireDate').valid && addCertificateForm.get('expireDate').touched) {
            @if (addCertificateForm.get('expireDate').errors && addCertificateForm.get('expireDate').errors['matDatepickerMin']) {
              <span i18n="@@pastDateError">Date can not be in past!</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100 product-field" appearance="outline">
        <mat-chip-grid #chipList>
          <div class="chips-wrapper">
            @for (product of products; track product; let index = $index) {
              <mat-chip-row
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(product, index)">
                {{product.name}}
                @if (removable) {
                  <mat-icon matChipRemove i18n-aria-label aria-label="Remove">cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </div>
          <input
            data-testid="add_edit_certificate_products_input"
            (keyup)="searchProduct($event)"
            placeholder="Products *"
            #productInput
            required
            [formControl]="productCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (product of filteredProducts | async; track product) {
            <mat-option [value]="product">
              {{product.name}}
            </mat-option>
          }
        </mat-autocomplete>

        @if (isLoading) {
          <mat-icon class="cursor" matSuffix>
            <mat-spinner class="spinner" diameter="20"></mat-spinner>
          </mat-icon>
        }
      </mat-form-field>

      @if (invalidProducts) {
        <div i18n="@@invalidProducts" class="error">Please enter products to proceed!</div>
      }

      <div class="d-flex align-items-base">
        @if (!fileIconOn) {
          <mat-form-field class="flex-grow" appearance="outline">
            <mat-label i18n="@@certificateLinkLabel">Certificate link</mat-label>
            <input data-testid="add_edit_certificate_link" matInput id="link" placeholder="Certificate link" i18n-placeholder="@@certificateLinkPlaceholder" name="link" formControlName="link" required />
            <mat-error>
              @if (!addCertificateForm.get('link').valid && addCertificateForm.get('link').touched) {
                  @if (addCertificateForm.get('link').errors && addCertificateForm.get('link').errors['required']) {
                    <span i18n="@@inValidRequiredField">This field is required</span>
                  }
              }
              @if (addCertificateForm.get('link').errors && addCertificateForm.get('link').errors['pattern']) {
                <span i18n="@@inValidLink">Please add correct link!</span>
              }
            </mat-error>
          </mat-form-field>
        }
        @if (fileIconOn) {
          <mat-form-field (click)="imgFileInput.click();" class="flex-grow" appearance="outline">
            <mat-label i18n="@@certificateFileLabel">Certificate file *</mat-label>
            <input data-testid="add_edit_certificate_file" matInput id="file" placeholder="Certificate file *" i18n-placeholder="@@certificateFilePlaceholder" name="file" formControlName="file" required />
            <mat-error>
              @if (!addCertificateForm.get('file').valid && addCertificateForm.get('file').touched) {
                @if (addCertificateForm.get('file').errors && addCertificateForm.get('file').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
            </mat-error>
          </mat-form-field>
        }

        <mat-icon class="{{!fileIconOn ? 'cursor off-icon-color ' : 'cursor on-icon-color'}}" (click)="imgFileInput.click();toggleIcon('file')" i18n-aria-label aria-label="Select file">insert_drive_file</mat-icon>
        <mat-icon class="{{fileIconOn ? 'cursor off-icon-color link-icon' : 'cursor on-icon-color link-icon'}}" (click)="toggleIcon('link')" i18n-aria-label aria-label="Select link">insert_link</mat-icon>
        <input accept=".png, .jpg, .jpeg, .txt, .html, .pdf, .rtf, .doc, .docx, .ppt, .pptx, .xls, .xlsx" hidden type="file" onclick="this.value = null" #imgFileInput (change)="previewImage($event.target.files)"/>
      </div>

      @if (invalidFiles) {
        <div i18n="@@invalidFilesMessage" class="error">Please enter files to proceed!</div>
      }
    </div>

    <div>
      @if (type === 'Add') {
        <button i18n="@@add" data-testid="add_certificate_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add') {
        <button i18n="@@save" data-testid="edit_certificate_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>